import { render, staticRenderFns } from "./pop_AiFreeLectureList.vue?vue&type=template&id=6610cf55&scoped=true&"
import script from "./pop_AiFreeLectureList.vue?vue&type=script&lang=js&"
export * from "./pop_AiFreeLectureList.vue?vue&type=script&lang=js&"
import style0 from "./pop_AiFreeLectureList.vue?vue&type=style&index=0&id=6610cf55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610cf55",
  null
  
)

export default component.exports